module.exports = __webpack_public_path__ + "img/pauli-x-root-dagger-35.4862286b.svg";